//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UserClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type SendPasswordForgottenUserQueryParameters = {
  userEmail?: string | undefined ;
}


export function registerNewUserUrl(): string {
  let url_ = getBaseUrl() + "/api/user";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function registerNewUserMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'registerNewUser',
    ]);
}

/**
 * Registers new user in the system.
 * @param dto Data for the user creation.
 */
export function useRegisterNewUserMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.RegisterNewUserDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.RegisterNewUserDto, TContext> {
  const key = registerNewUserMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.RegisterNewUserDto) => Client.registerNewUser(dto),
    mutationKey: key,
  });
}
  
export function confirmUserMailUrl(): string {
  let url_ = getBaseUrl() + "/api/user/confirm";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function confirmUserMailMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'confirmUserMail',
    ]);
}

/**
 * Confirms user's email and activates account
 * @param dto Data for email confirmation.
 */
export function useConfirmUserMailMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ConfirmUserMailDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ConfirmUserMailDto, TContext> {
  const key = confirmUserMailMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ConfirmUserMailDto) => Client.confirmUserMail(dto),
    mutationKey: key,
  });
}
  
export function sendPasswordForgottenUrl(userEmail?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/user/password-forgotten?";
if (userEmail === null)
    throw new Error("The parameter 'userEmail' cannot be null.");
else if (userEmail !== undefined)
    url_ += "userEmail=" + encodeURIComponent("" + userEmail) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendPasswordForgottenMutationKey(userEmail?: string | undefined): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'sendPasswordForgotten',
      userEmail as any,
    ]);
}

/**
 * Resets user's password and sends an e-mail with token to setup new one.
 * @param userEmail (optional) User e-mail for whom password should be reset.
 */
export function useSendPasswordForgottenMutation<TContext>(userEmail?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sendPasswordForgottenMutationKey(userEmail);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendPasswordForgotten(userEmail),
    mutationKey: key,
  });
}
  
type SendPasswordForgotten__MutationParameters = SendPasswordForgottenUserQueryParameters

/**
 * Resets user's password and sends an e-mail with token to setup new one.
 * @param userEmail (optional) User e-mail for whom password should be reset.
 */
export function useSendPasswordForgottenMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendPasswordForgotten__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendPasswordForgottenUserQueryParameters}): UseMutationResult<void, unknown, SendPasswordForgotten__MutationParameters, TContext> {
  const key = sendPasswordForgottenMutationKey(options?.parameters?.userEmail!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendPasswordForgotten__MutationParameters) => Client.sendPasswordForgotten(data.userEmail ?? options?.parameters?.userEmail!),
  mutationKey: key,
});
}
  
export function resetPasswordUrl(): string {
  let url_ = getBaseUrl() + "/api/user/reset-password";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetPasswordMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'resetPassword',
    ]);
}

/**
 * Resets user's password with the given token.
 * @param dto Data for password changing.
 */
export function useResetPasswordMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ResetPasswordDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ResetPasswordDto, TContext> {
  const key = resetPasswordMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ResetPasswordDto) => Client.resetPassword(dto),
    mutationKey: key,
  });
}
  
export function getMyInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/user/my-info";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMyInfoDefaultOptions: Omit<UseQueryOptions<Types.UserInfoDto, unknown, Types.UserInfoDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UserInfoDto, unknown, Types.UserInfoDto>, 'queryFn'>> = {
};
export function getGetMyInfoDefaultOptions() {
  return getMyInfoDefaultOptions;
};
export function setGetMyInfoDefaultOptions(options: typeof getMyInfoDefaultOptions) {
  getMyInfoDefaultOptions = options;
}

export function getMyInfoQueryKey(): QueryKey;
export function getMyInfoQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserClient',
      'getMyInfo',
    ]);
}
export function __getMyInfo(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getMyInfo(
axiosConfig    );
}

/**
 * Returns user's info.
 */
export function useGetMyInfoQuery<TSelectData = Types.UserInfoDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.UserInfoDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMyInfoQuery<TSelectData = Types.UserInfoDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserInfoDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UserInfoDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getMyInfo(context, axiosConfig) : __getMyInfo,
    queryKey: getMyInfoQueryKey(),
    ...getMyInfoDefaultOptions as unknown as Omit<UseQueryOptions<Types.UserInfoDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns user's info.
 */
export function setGetMyInfoData(queryClient: QueryClient, updater: (data: Types.UserInfoDto | undefined) => Types.UserInfoDto, ) {
  queryClient.setQueryData(getMyInfoQueryKey(),
    updater
  );
}

/**
 * Returns user's info.
 */
export function setGetMyInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserInfoDto | undefined) => Types.UserInfoDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getMySubscriptionInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/user/subscription-info";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMySubscriptionInfoDefaultOptions: Omit<UseQueryOptions<Types.UserSubscriptionInfoDto, unknown, Types.UserSubscriptionInfoDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UserSubscriptionInfoDto, unknown, Types.UserSubscriptionInfoDto>, 'queryFn'>> = {
};
export function getGetMySubscriptionInfoDefaultOptions() {
  return getMySubscriptionInfoDefaultOptions;
};
export function setGetMySubscriptionInfoDefaultOptions(options: typeof getMySubscriptionInfoDefaultOptions) {
  getMySubscriptionInfoDefaultOptions = options;
}

export function getMySubscriptionInfoQueryKey(): QueryKey;
export function getMySubscriptionInfoQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserClient',
      'getMySubscriptionInfo',
    ]);
}
export function __getMySubscriptionInfo(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getMySubscriptionInfo(
axiosConfig    );
}

/**
 * Returns user's subscription info.
 */
export function useGetMySubscriptionInfoQuery<TSelectData = Types.UserSubscriptionInfoDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.UserSubscriptionInfoDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMySubscriptionInfoQuery<TSelectData = Types.UserSubscriptionInfoDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserSubscriptionInfoDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UserSubscriptionInfoDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getMySubscriptionInfo(context, axiosConfig) : __getMySubscriptionInfo,
    queryKey: getMySubscriptionInfoQueryKey(),
    ...getMySubscriptionInfoDefaultOptions as unknown as Omit<UseQueryOptions<Types.UserSubscriptionInfoDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Returns user's subscription info.
 */
export function setGetMySubscriptionInfoData(queryClient: QueryClient, updater: (data: Types.UserSubscriptionInfoDto | undefined) => Types.UserSubscriptionInfoDto, ) {
  queryClient.setQueryData(getMySubscriptionInfoQueryKey(),
    updater
  );
}

/**
 * Returns user's subscription info.
 */
export function setGetMySubscriptionInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserSubscriptionInfoDto | undefined) => Types.UserSubscriptionInfoDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateUserNameUrl(): string {
  let url_ = getBaseUrl() + "/api/user/username";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateUserNameMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'updateUserName',
    ]);
}

/**
 * Updates user's name.
 */
export function useUpdateUserNameMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.UpdateUserNameDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateUserNameDto, TContext> {
  const key = updateUserNameMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateUserNameDto) => Client.updateUserName(dto),
    mutationKey: key,
  });
}
  
export function migrateToEmailLoginUrl(): string {
  let url_ = getBaseUrl() + "/api/user/migrate-to-email-login";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function migrateToEmailLoginMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'migrateToEmailLogin',
    ]);
}

/**
 * Initiates migration from social network login to email/password authentication.
Sends a password setup link to the provided email address.
 */
export function useMigrateToEmailLoginMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.MigrateToEmailLoginDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MigrateToEmailLoginDto, TContext> {
  const key = migrateToEmailLoginMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.MigrateToEmailLoginDto) => Client.migrateToEmailLogin(dto),
    mutationKey: key,
  });
}